import { createGetApi, createPostApi } from 'friday-async';

export interface DictionaryItem {
  label: string;
  value: string;
  parentValue?: string;
  sort?: number;
}

class Apis {
  public list = createGetApi<void>({
    url: '/dictionary/list',
  });

  public create = createPostApi<{code: string; name: string}>({
    url: '/dictionary/create',
  });

  public update = createPostApi<{_id: string; code: string; name: string}>({
    url: '/dictionary/update',
  });

  public remove = createPostApi<{_id: string}>({
    url: '/dictionary/remove',
  });

  public addItem = createPostApi<{_id: string; item: DictionaryItem}>({
    url: '/dictionary/addItem',
  });

  public updateItem = createPostApi<{_id: string; itemValue: string; item: DictionaryItem}>({
    url: '/dictionary/updateItem',
  });

  public removeItem = createPostApi<{_id: string; itemValue: string}>({
    url: '/dictionary/removeItem',
  });

  public importXlsx = createPostApi<{dictCode: string; dictName?: string; mode?: string}>({
    url: '/dictionary/importXlsx',
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export default Apis;
